import React, { useEffect } from "react";
import { Card, Spin } from 'antd';
import BusinessForm from "./businesses/BusinessForm";
import { usePersistedStore } from "../store/persisted-store";
import NotFound from "./NotFound";

const WhiteLabelSettings = () => {

    const { business, getcurrentBusinessBytoken } = usePersistedStore();
    const currentBusiness = business.currentBusiness.data;
    const businessToken = business.currentBusiness.token;
    const loading = business.businesses.loading;
    const businessType = currentBusiness?.type
    const businessId = currentBusiness?.id


    useEffect(() => {
        if (businessToken)
            getcurrentBusinessBytoken(businessToken)
    }, [])


    return (
        <>
            {
                (businessType === 2 || businessId === 13) ?
                    <Card>
                        <Spin style={{ marginTop: "10px" }} spinning={loading}>
                            <BusinessForm
                                showInfoItems={false}
                                business={currentBusiness}
                            />

                        </Spin>
                    </Card>
                    : <NotFound />
            }
        </>
    )
}
export default WhiteLabelSettings;